import { hingePositions } from '@planner/config';
import { securityLockPositions } from './derive.js';
export function doorElevation(type, size, lockSide, lockHeight) {
    // SVG design units; PDF rendering scales the same geometry to its page.
    const height = 372;
    const width = Math.min(215, Math.max(120, (height * size.width) / size.height));
    const frame = 11;
    const yFromBottom = (mm) => height - (height * mm) / size.height;
    const handleX = lockSide === 'left' ? frame / 2 + 2 : width - frame / 2 - 2;
    const handleY = yFromBottom(lockHeight);
    const hingeX = lockSide === 'left' ? width : 0;
    const bounds = { x: frame, y: frame, width: width - 2 * frame, height: height - 2 * frame };
    const path = type === 'security'
        ? Array.from({ length: 42 }, (_, index) => {
            const px = frame + index * 5;
            const py = frame + index * 9;
            return `M ${px} ${frame} V ${height - frame} M ${frame} ${py} H ${width - frame}`;
        }).join(' ')
        : Array.from({ length: 18 }, (_, index) => {
            const offset = index * 38 - height;
            return `M ${frame + offset} ${frame} l ${height} ${height} M ${frame + offset} ${height - frame} l ${height} -${height}`;
        }).join(' ');
    const hardware = [...hingePositions(size.height)]
        .reverse()
        .map((position) => ({
        x: hingeX - 5,
        y: yFromBottom(position) - 9,
        width: 10,
        height: 18,
        rx: 1.5,
        fill: '#2F3437',
    }));
    hardware.push({ x: handleX - 5, y: handleY - 14, width: 10, height: 28, rx: 2, fill: '#2F3437' }, {
        x: lockSide === 'left' ? handleX + 4 : handleX - 22,
        y: handleY - 2,
        width: 18,
        height: 4,
        rx: 2,
        fill: '#111111',
    });
    const locks = type === 'security' ? securityLockPositions(lockHeight) : undefined;
    if (locks) {
        for (const position of [locks.top, locks.bottom]) {
            if (position === undefined)
                continue;
            hardware.push({
                x: handleX - 4,
                y: yFromBottom(position) - 7,
                width: 8,
                height: 14,
                rx: 1.5,
                fill: '#2F3437',
            });
        }
    }
    return {
        width,
        height,
        handleX,
        handleY,
        outerFrame: {
            x: 0,
            y: 0,
            width,
            height,
            fill: '#FFFFFF',
            stroke: '#1F2937',
            strokeWidth: 2,
        },
        innerFrame: {
            ...bounds,
            fill: 'none',
            stroke: '#1F2937',
            strokeWidth: 1.2,
        },
        infill: {
            bounds,
            path,
            fill: type === 'security' ? '#E9EAEA' : '#FFFFFF',
            stroke: type === 'security' ? '#6B7175' : '#2F3437',
            strokeWidth: type === 'security' ? 0.9 : 1.5,
        },
        hardware,
    };
}
//# sourceMappingURL=elevation.js.map